import PhoneInput from 'react-phone-input-2'
import { Button, Input, Space } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import React, { useCallback, useEffect, useState } from 'react'
import ru from 'react-phone-input-2/lang/ru.json'
import './style.css'

const { Compact } = Space

interface InputIntegerProps {
  value?: number
  onSearch: (value?: number) => void
  onChange: (value?: number) => void
  prefix?: string
  placeholder?: string
}

export const InputInteger: React.FC<InputIntegerProps> = ({
  value,
  onSearch,
  onChange,
  prefix = '',
  placeholder = '',
}) => {
  const [localValue, setLocalValue] = useState<number | undefined>(value)

  useEffect(() => {
    setLocalValue(value)
  }, [value])

  const handlerChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const inputValue = event.target.value
      const reg = /^\d*$/
      if (reg.test(inputValue)) {
        const realValue = inputValue.length ? Number(inputValue) : undefined
        setLocalValue(realValue)
        onChange(realValue)
      }
    },
    [onChange],
  )

  const handleSearch = useCallback(() => {
    onSearch(localValue)
  }, [localValue, onSearch])

  return (
    <Compact block style={{ width: 200 }}>
      {prefix ? (
        <Input
          value={prefix}
          readOnly
          style={{
            width: 52,
            pointerEvents: 'none',
            textAlign: 'center',
          }}
        />
      ) : null}
      <Input
        value={localValue !== undefined ? String(localValue) : ''}
        style={{ width: prefix ? 148 : 200 }}
        placeholder={placeholder}
        allowClear
        onChange={handlerChange}
        onPressEnter={handleSearch}
        maxLength={10}
      />
      <Button icon={<SearchOutlined />} onClick={handleSearch} style={{ borderColor: '#999999' }} />
    </Compact>
  )
}

interface InputPhoneProps {
  value?: string
  /** Вызывается при вводе (только обновление локального состояния) */
  onChange: (value?: string) => void
  /** Вызывается при клике на Search или Enter (применение фильтра). Если не передан — используется onChange */
  onSearch?: (value?: string) => void
}

export const InputPhone: React.FC<InputPhoneProps> = ({ value, onChange, onSearch }) => {
  const [localValue, setLocalValue] = useState<string | null>(value || null)
  const [length, setLength] = useState<number | undefined>()
  const applyCallback = onSearch ?? onChange

  useEffect(() => {
    setLocalValue(value || null)
  }, [value])

  const changePhone = useCallback(() => {
    if (localValue && localValue.length === length) {
      applyCallback(localValue)
    }
  }, [applyCallback, localValue, length])

  const handlerChange = useCallback(
    (v: string, c: any) => {
      setLength(c.format.match(/\./g).length)
      setLocalValue(v)
      onChange(v || undefined)
    },
    [onChange],
  )

  const clearLocal = useCallback(() => {
    setLocalValue('7')
    applyCallback(undefined)
  }, [applyCallback])

  return (
    <Compact block className="input-phone-compact">
      <div className="input-phone-wrapper">
        <PhoneInput
          containerClass="costumizedPhoneInput"
          value={localValue || ''}
          enableSearch={true}
          searchPlaceholder={'Поиск'}
          localization={ru}
          country={'ru'}
          onlyCountries={['ru', 'kz', 'by', 'tj', 'uz', 'am', 'kg', 'az', 'md', 'tm']}
          onEnterKeyPress={changePhone}
          onChange={(v, c) => handlerChange(v, c)}
        />
        {localValue && localValue.length >= 10 && (
          <span className="ant-input-suffix-costumized" onClick={clearLocal}>
            <span className="ant-input-clear-icon" role="button">
              <span role="img" aria-label="close-circle" className="anticon anticon-close-circle">
                <svg
                  viewBox="64 64 896 896"
                  focusable="false"
                  data-icon="close-circle"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7-3.7-1.9-5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" />
                </svg>
              </span>
            </span>
          </span>
        )}
      </div>
      <Button
        icon={<SearchOutlined />}
        onClick={changePhone}
        style={{ marginLeft: '-32px', borderRadius: '0 6px 6px 0', border: '1px solid #999999' }}
      />
    </Compact>
  )
}
